module.exports = require("./fr-PM");